import React, { useState } from 'react'

import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { above } from '../../../style/design-system'
import VideoLazyload from '../../reusables/VideoLazyload'
import YouTubeEmbed from '../../reusables/YouTubeEmbed'

const VideoWithThumbnails = ({ className }) => {
  const staticQ = useStaticQuery(graphql`
    {
      posterCare2024: file(absolutePath: { regex: "/ychbc/ychbc-video-poster.webp/" }) {
        publicURL
        childImageSharp {
          gatsbyImageData(width: 600, quality: 85, placeholder: NONE, layout: CONSTRAINED)
        }
      }
      posterCare2022: file(absolutePath: { regex: "/home/care-mantra-2022-fall-poster.jpg/" }) {
        publicURL
        childImageSharp {
          gatsbyImageData(width: 600, quality: 85, placeholder: NONE, layout: CONSTRAINED)
        }
      }
      posterCare2021: file(absolutePath: { regex: "/home/care-mantra-video-poster.jpg/" }) {
        publicURL
        childImageSharp {
          gatsbyImageData(width: 600, quality: 85, placeholder: NONE, layout: CONSTRAINED)
        }
      }
      posterStudentTestimonial: file(absolutePath: { regex: "/home/student-testimonial-poster.jpg/" }) {
        publicURL
        childImageSharp {
          gatsbyImageData(width: 600, quality: 85, placeholder: NONE, layout: CONSTRAINED)
        }
      }
    }
  `)

  const [videos, setVideos] = useState([
    {
      poster: staticQ.posterCare2024.childImageSharp.gatsbyImageData,
      posterAlt: "2024 You Can't Help but Care Video Poster",
      videoID: 'RyxuNey1Bls',
    },
    {
      poster: staticQ.posterCare2022.childImageSharp.gatsbyImageData,
      posterAlt: ' 2022 Care Pays Back Video Poster',
      videoID: 'u3VVs4wwVQI',
    },
    {
      poster: staticQ.posterCare2021.childImageSharp.gatsbyImageData,
      posterAlt: ' 2021 Care Pays Back Video Poster',
      videoID: '5AXsIBuxjl0',
    },
    {
      poster: staticQ.posterStudentTestimonial.childImageSharp.gatsbyImageData,
      posterAlt: 'Ultimate Medical Academy Student Testimonial Poster',
      videoID: 'y7di4HmTWPw',
    },
  ])

  const handleThumbnailClick = (e) => {
    const indexClicked = e.currentTarget.dataset.index
    const stateCopy = videos.slice(0)
    const thumbnailBecomingMainVideo = stateCopy[indexClicked]
    const mainVideoBecomingThumbnail = stateCopy[0]
    stateCopy[0] = thumbnailBecomingMainVideo
    stateCopy[indexClicked] = mainVideoBecomingThumbnail
    setVideos(stateCopy)
  }

  const renderThumbnails = () => {
    const thumbnailVideos = videos.slice(1)
    return thumbnailVideos.map((thumbnail, i) => (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus
      <div
        className="thumbnail"
        onClick={handleThumbnailClick}
        key={thumbnail.videoID}
        data-index={i + 1}
        role="button">
        <GatsbyImage image={thumbnail.poster} alt={thumbnail.posterAlt} />
      </div>
    ))
  }

  return (
    <div className={className}>
      <VideoLazyload
        displayPlayIcon
        className="video-wrapper"
        posterAlt="Care Pays Back Video Poster"
        posterGatsbyImg={{
          image: videos[0].poster,
        }}>
        <YouTubeEmbed autoplay title="UMA" videoId={videos[0].videoID} />
      </VideoLazyload>
      <div className="thumbnails">{renderThumbnails()}</div>
    </div>
  )
}

export default styled(VideoWithThumbnails)`
  .thumbnails {
    overflow-x: auto;
    white-space: nowrap;
    padding-top: 0.5rem;
    padding-left: 0.4rem;
    width: calc(100% - 0.4rem);
    .thumbnail {
      cursor: pointer;
      display: inline-block;
      margin: 0 0.5rem;
      height: 4rem;
      width: 6rem;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      ${above.sm`
        height: 5rem;
        width: 8rem;
      `}
    }
  }
`

VideoWithThumbnails.propTypes = {
  className: PropTypes.string,
}

VideoWithThumbnails.defaultProps = {
  className: '',
}
